import { render, staticRenderFns } from "./PreparationVisaMailPopup.vue?vue&type=template&id=7722fbf5&"
import script from "./PreparationVisaMailPopup.vue?vue&type=script&lang=js&"
export * from "./PreparationVisaMailPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports